import React, { Fragment, Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { CardHeader, Nav, NavItem, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import IntlMessages from '../../../../../helpers/IntlMessages';
import ChatbotsStats from './components/ChatbotStats';

const style_css = `.nav-tabs .nav-link.active::before,.nav-tabs .nav-item.show .nav-link::before {
    top:auto !important;
    bottom: 0 !important;
  }
  .active{
    background-color:transparent;
  }`;
class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAciveTab: 'chatbot',
    };
  }

  render() {
    const allowedEmails = [
      'andy@bookmebob.com',
      'andy@myma.ai',
      'david@bookmebob.com',
      'david@myma.ai',
      'accounts@myma.ai',
    ];
    const { email } = this.props;

    if (!allowedEmails.includes(email)) {
      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '40px',
          }}
        >
          Unauthorized Access
        </div>
      );
    }
    return (
      <Fragment>
        <CardHeader
          className="mb-0"
          style={{ marginLeft: '-1.22rem', marginRight: '-1.22rem' }}
        >
          <Nav tabs className="card-header-tabs separator-tabs mb-1 ml-0 mr-0">
            <style>{style_css}</style>
            <NavItem
              className="text-center"
              style={{ width: 'auto', background: '' }}
            >
              <NavLink
                style={{ background: 'none', cursor: 'pointer' }}
                className={classnames({
                  active: this.state.isAciveTab === 'chatbot',
                  'nav-link': true,
                })}
                onClick={() => {
                  this.setState({ isAciveTab: 'chatbot' });
                }}
                to="#"
              >
                <span
                  style={{
                    color: `${this.state.isAciveTab === 'chatbot' ? 'var(--theme-color-1)' : '#8f8f8f'}`,
                    fontWeight: 600,
                  }}
                >
                  <IntlMessages id="dashboards.chatbots" />
                </span>
              </NavLink>
            </NavItem>
            <NavItem className="text-center" style={{ width: 'auto' }}>
              <NavLink
                style={{ background: 'none', cursor: 'pointer' }}
                className={classnames({
                  active: this.state.isAciveTab === 'Compendium',
                  'nav-link': true,
                })}
                onClick={() => {
                  this.setState({ isAciveTab: 'Compendium' });
                }}
                to="#"
              >
                <span
                  style={{
                    color: `${this.state.isAciveTab === 'Compendium' ? 'var(--theme-color-1)' : '#8f8f8f'}`,
                    fontWeight: 600,
                  }}
                >
                  {' '}
                  <IntlMessages id="dashboards.compendium" />
                </span>
              </NavLink>
            </NavItem>
            <NavItem
              className="text-center"
              style={{ width: 'auto', background: '' }}
            >
              <NavLink
                style={{ background: 'none', cursor: 'pointer' }}
                className={classnames({
                  active: this.state.isAciveTab === 'giftvoucher',
                  'nav-link': true,
                })}
                onClick={() => {
                  this.setState({ isAciveTab: 'giftvoucher' });
                }}
                to="#"
              >
                <span
                  style={{
                    color: `${this.state.isAciveTab === 'giftvoucher' ? 'var(--theme-color-1)' : '#8f8f8f'}`,
                    fontWeight: 600,
                  }}
                >
                  {' '}
                  <IntlMessages id="dashboards.gift-voucher" />
                </span>
              </NavLink>
            </NavItem>
            <NavItem
              className="text-center"
              style={{ width: 'auto', background: '' }}
            >
              <NavLink
                style={{ background: 'none', cursor: 'pointer' }}
                className={classnames({
                  active: this.state.isAciveTab === 'space',
                  'nav-link': true,
                })}
                onClick={() => {
                  this.setState({ isAciveTab: 'space' });
                }}
                to="#"
              >
                <span
                  style={{
                    color: `${this.state.isAciveTab === 'space' ? 'var(--theme-color-1)' : '#8f8f8f'}`,
                    fontWeight: 600,
                  }}
                >
                  <IntlMessages id="dashboards.space-booking" />
                </span>
              </NavLink>
            </NavItem>
          </Nav>
        </CardHeader>
        <TabContent activeTab={this.state.isAciveTab} className="">
          <TabPane
            tabId="chatbot"
            className="chat-app-tab-pane"
            style={{ width: 'auto', background: 'transparent' }}
          >
            <ChatbotsStats
              propertyId={this.props.propertyId}
              locale={this.props.locale}
              timeZone={this.props.timeZone}
              groupBillingCurrency={this.props.groupBillingCurrency}
            ></ChatbotsStats>
          </TabPane>
        </TabContent>
      </Fragment>
    );
  }
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, email, locale, timeZone, groupBillingCurrency } =
    settings;
  return {
    propertyId,
    email,
    locale,
    timeZone,
    groupBillingCurrency,
  };
};
export default injectIntl(connect(mapStateToProps, {})(Index));
